export default {
    user: null,
    isRetrieved: false,
}
